import axios from 'axios';

export default axios.create({
    baseURL: 'https://ethis-api.tesdev.xyz',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    }
});